import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetBranchesApiParameter extends ApiParameter {}

export interface BranchDto {
    name: string;
    number: number;
    email: string;
}

export interface ProvinceDto {
    province: string;
    branches: BranchDto[];
}

export interface BranchModel {
    id: string;
    name: string
}

export interface ProvinceModel {
    province: string;
    branches: BranchModel[];
}

export interface GetBranchesApiResponse {
    branches: BranchModel[];
}

export function getBranches(parameter: GetBranchesApiParameter) {
    return get<ProvinceDto[]>("api/v1/getBranchData", parameter).then(response =>
        response.map(p => ({
            province: p.province,
            branches: p.branches.map(b => ({
                id: b.number.toString(),
                name: b.name,
            })),
        }))
    );
}

